import { ofType, combineEpics } from "redux-observable";
import { switchMap, mergeMap } from "rxjs/operators";
import { from, of } from "rxjs";
import { studyEnabled, studyDisabled, studyStateUpdating, studyDeleted } from "../ducks/AnalysisStudyListActions.js";
import AnalysisStudyListConstants from "../ducks/AnalysisStudyListConstants.js";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { AnalysisState } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
const enableDisableStudyEpic = (action$) => {
  return action$.pipe(
    ofType(AnalysisStudyListConstants.ENABLE_STUDY, AnalysisStudyListConstants.DISABLE_STUDY),
    switchMap((value) => {
      const studyId = value.payload.studyId;
      const setActive = value.type === AnalysisStudyListConstants.ENABLE_STUDY;
      const setActiveStateResult = from(
        AnalysisResourceV2.updateAnalysis(value.payload.workspaceId, studyId, {
          name: value.payload.title,
          state: setActive ? AnalysisState.Active : AnalysisState.Disabled
        })
      ).pipe(
        mergeMap((r) => {
          return of(
            setActive ? studyEnabled(value.payload) : studyDisabled(value.payload)
          );
        })
      );
      return of(setActiveStateResult, of(studyStateUpdating(value.payload))).pipe(mergeMap((x) => x));
    })
  );
};
const deleteStudyEpic = (action$) => {
  return action$.pipe(
    ofType(AnalysisStudyListConstants.DELETE_STUDY),
    switchMap((value) => {
      const studyId = value.payload.studyId;
      const deleteStudyResult = from(AnalysisResourceV2.deleteAnalysis(value.payload.workspaceId, studyId)).pipe(
        mergeMap((r) => {
          return of(studyDeleted(value.payload));
        })
      );
      return of(deleteStudyResult, of(studyStateUpdating(value.payload))).pipe(mergeMap((x) => x));
    })
  );
};
const provideAnalysisStudyWriteEpics = () => {
  const analysisStudyWriteEpics = combineEpics(enableDisableStudyEpic, deleteStudyEpic);
  return analysisStudyWriteEpics;
};
export {
  deleteStudyEpic,
  enableDisableStudyEpic,
  provideAnalysisStudyWriteEpics
};
//# sourceMappingURL=AnalysisStudyWriteEpic.js.map
